document.addEventListener("DOMContentLoaded", function () {
  const productForm = document.querySelector(".product-form");
  const productFormButton = document.querySelector(".product-form__add-btn");
  const fixedStickyBar = document.getElementById("fixed-sticky-bar");
  const footer = document.getElementById("footer");
  const headerContainer = document.querySelector("header-container");

  if (!productFormButton || !fixedStickyBar || !headerContainer || !productForm) {
    return;
  }
  
  const headerHeight = headerContainer.offsetHeight;
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          fixedStickyBar.classList.remove("show");
          if (footer) footer.style.paddingBottom = "0";
        } else {
          fixedStickyBar.classList.add("show");
          if (footer) footer.style.paddingBottom = "80px";
        }
      });
    },
    {
      root: null,
      rootMargin: `-${headerHeight}px 0px 0px 0px`,
      threshold: 0,
    }
  );

  observer.observe(productFormButton);

  const btnSelectOptions = document.getElementById("sticky-select-options");
  if (btnSelectOptions) {
    btnSelectOptions.addEventListener("click", function () {
      productForm.scrollIntoView({ behavior: "smooth", block: "center" });
    });
  }
  const btnAddToCart = document.getElementById("sticky-add-to-cart");
  if (btnAddToCart) {
    btnAddToCart.addEventListener("click", function () {
      if (productFormButton) productFormButton.click();
    });
  }
});